import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const o = l((i, c) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: c,
    ...i,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...e,
        children: [
          /* @__PURE__ */ s.jsx("g", { fill: "currentColor", clipPath: "url(#clip0_9072_2738)", children: /* @__PURE__ */ s.jsx("path", { d: "M24 21c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M17 30c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M32 30c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633" }) }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_9072_2738", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyAcne3Icon";
export {
  o as AgencyAcne3Icon,
  o as default
};
//# sourceMappingURL=index.js.map
